import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Modal.css";
import "./GuideEditModal.css";
import { GuideAttributes } from "../../Models/Guide";
import DataBase from "../../dataBase/liquidGuides";
import Common from "../../Common/Common";
import { languages } from "../../Data/Languages";
import { countries } from "../../Data/Countries";
import { DateTime } from "luxon";
import MultiSelectModal from "./MultiSelectModal";
import AlertModal from "./AlertModal";
import CitiesDialog from "./CitiesDialog";
import LocationPickerDialog from "./LocationPickerDialog";
import ImageDialog from "./ImageDialog";
import UsersDialog from "./UsersDialog";

const icoBook  = solid("book-open");
const icoPen   = solid("pen-to-square");
const icoXmark = solid("xmark");
const icoCheck = solid("check");
const icoChevR = solid("chevron-right");

class GuideEditModal extends Component {
  constructor(props) {
    super(props);
    // this.props.guide_info mirrors the guide's Firestore doc — null for a
    // guide that only exists locally/in-memory (e.g. "Start with a blank
    // guide" -> Build My Trip, never saved to the cloud). "Edit Guide Info"
    // always opens in "UPDATE" mode regardless, so without this fallback,
    // editing such a guide's info crashed reading guide_name off null. The
    // live guide's own attributes are the correct source of truth here
    // anyway. Found 2026-08-27.
    const guideAttributes = this.props.guide_info || window.guide_obj.attributes;
    const mode = this.props.mode;
    const guide_info_id = this.props.guide_info_id;
    let initialName = "New Guide";
    let initialDescription = "";
    let initialRating = 0;
    let initialLanguage = "English";
    let initialImage = "";
    let initialCountries = [];
    let initialCities = [];
    let initialAccess = [];
    if (mode !== "ADD") {
      initialName = guideAttributes["guide_name"];
      initialDescription = guideAttributes["description"];
      initialRating = guideAttributes["rating"];
      initialLanguage = guideAttributes["language"];
      initialImage = guideAttributes["image"];
      if (Array.isArray(guideAttributes["access"]))
        initialAccess = guideAttributes["access"].filter((a) => typeof a === "string");
      if (typeof guideAttributes["countries"] == "undefined") initialCountries = [];
      else initialCountries = guideAttributes["countries"];
      if (typeof guideAttributes["cities"] == "undefined") initialCities = [];
      else initialCities = guideAttributes["cities"];
    }
    let processed_guide_infos = window.guide_obj.classifyAuthorizationInfo(guideAttributes, this.props.user_info.uid);
    const processed_guide_info = processed_guide_infos;
    let Featured = "No";
    if (guideAttributes.type === "Featured") Featured = "Yes";
    this.state = {
      guideAttributes: guideAttributes,
      Name: initialName,
      Description: initialDescription,
      Rating: initialRating,
      image: initialImage,
      Language: initialLanguage,
      Countries: initialCountries,
      Cities: initialCities,
      CitiesShow: false,
      cities_sorted: [],
      LocationPickerShow: false,
      Users: [],
      AccessNames: [],
      Access: initialAccess,
      ShareAll: "None",
      Group_Read: [],
      Group_Copy: [],
      Group_Modify: [],
      Group_Read_Names: [],
      Group_Copy_Names: [],
      Group_Modify_Names: [],
      Group_Read_List: [],
      Group_Copy_List: [],
      Group_Modify_List: [],
      Auth: "None",
      Featured: Featured,
      textValueLat:
        typeof guideAttributes.base_location === "undefined" ? 0 : guideAttributes.base_location.latitude.toFixed(6),
      textValueLongi:
        typeof guideAttributes.base_location === "undefined" ? 0 : guideAttributes.base_location.longitude.toFixed(6),
      processed_guide_info: processed_guide_info,
      guide_info_id: guide_info_id,

      MultiselectItems: [],
      MultiselectSelectedItems: [],
      MultiselectMode: "uni",
      MultiselectCallback: null,
      MultiselectTitle: "Select",
      MultiselectSearchText: "",
      ShowMultiselect: false,

      UsersDialogShow: false,

      AlertModalShow: false,
      AlertModalTitle: "",
      AlertModalMessage: "",
      AlertModalButtons: [],
    };
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeDescription = this.handleChangeDescription.bind(this);
    this.handleChangeRating = this.handleChangeRating.bind(this);
  }

  componentDidMount() {
    this.processAccess();
  }

  _processAccess = false;
  processAccess = () => {
    let Featured = "No";
    let ShareAll = "None";
    let Auth = "None";
    let Group_Read = [];
    let Group_Copy = [];
    let Group_Modify = [];
    if (this.state.guideAttributes.type === "Featured") Featured = "Yes";
    if (this.state.Access.length != 0) {
      this.state.Access.forEach((access) => {
        if (access == "All_R") ShareAll = "Read";
        else if (access == "All_C") ShareAll = "Copy";
        else if (access == "All_M") ShareAll = "Modify";
        if (access == this.props.user_info.uid) Auth = "Modify";
        if (access.includes(":")) {
          let access_parts = access.split(":");
          if (access_parts[1] == "R") {
            Group_Read.push(access_parts[0]);
            if (access_parts[0] == this.props.user_info.uid) Auth = "Read";
          } else if (access_parts[1] == "C") {
            Group_Copy.push(access_parts[0]);
            if (access_parts[0] == this.props.user_info.uid) Auth = "Copy";
          } else if (access_parts[1] == "M") {
            Group_Modify.push(access_parts[0]);
            if (access_parts[0] == this.props.user_info.uid) Auth = "Modify";
          }
        }
      });
    }
    if (Auth == "None") {
      if (ShareAll == "Read") Auth = "Read";
      if (ShareAll == "Copy") Auth = "Copy";
      if (ShareAll == "Modify") Auth = "Modify";
    }
    this.setState({
      Featured: Featured,
      ShareAll: ShareAll,
      Auth: Auth,
      Group_Read: Group_Read,
      Group_Copy: Group_Copy,
      Group_Modify: Group_Modify,
    });
    if (Group_Read.length > 0 || Group_Copy.length > 0 || Group_Modify.length > 0) {
      this.getUserDetails(Group_Read, Group_Copy, Group_Modify);
    }
  };

  getUserDetails = (Group_Read, Group_Copy, Group_Modify) => {
    Group_Read.forEach((gr) => { DataBase.findUserByUID(gr, this.findUserByUIDCallbackRead); });
    Group_Copy.forEach((gr) => { DataBase.findUserByUID(gr, this.findUserByUIDCallbackCopy); });
    Group_Modify.forEach((gr) => { DataBase.findUserByUID(gr, this.findUserByUIDCallbackModify); });
  };

  findUserByUIDCallbackRead = async (res) => {
    if (res.pass === true) {
      const user_info = res.res;
      const label = `${user_info.first_name}, ${user_info.last_name}`;
      this.setState((prev) => ({
        Group_Read: [...prev.Group_Read, user_info.uid],
        Group_Read_Names: [...prev.Group_Read_Names, label],
        Group_Read_List: [...prev.Group_Read_List, { name: user_info.uid, value: user_info.uid, label }],
      }));
    }
  };

  findUserByUIDCallbackCopy = async (res) => {
    if (res.pass === true) {
      const user_info = res.res;
      const label = `${user_info.first_name}, ${user_info.last_name}`;
      this.setState((prev) => ({
        Group_Copy: [...prev.Group_Copy, user_info.uid],
        Group_Copy_Names: [...prev.Group_Copy_Names, label],
        Group_Copy_List: [...prev.Group_Copy_List, { name: user_info.uid, value: user_info.uid, label }],
      }));
    }
  };

  findUserByUIDCallbackModify = async (res) => {
    if (res.pass === true) {
      const user_info = res.res;
      const label = `${user_info.first_name}, ${user_info.last_name}`;
      this.setState((prev) => ({
        Group_Modify: [...prev.Group_Modify, user_info.uid],
        Group_Modify_Names: [...prev.Group_Modify_Names, label],
        Group_Modify_List: [...prev.Group_Modify_List, { name: user_info.uid, value: user_info.uid, label }],
      }));
    }
  };

  processGroups = (Users) => {
    let Group_Read_Names = [];
    this.state.Group_Read.forEach((user_id) => {
      const index = Users.findIndex((User) => User.value == user_id);
      if (index != -1) Group_Read_Names.push(Users[index].label);
    });
    let Group_Copy_Names = [];
    this.state.Group_Copy.forEach((user_id) => {
      const index = Users.findIndex((User) => User.value == user_id);
      if (index != -1) Group_Copy_Names.push(Users[index].label);
    });
    let Group_Modify_Names = [];
    this.state.Group_Modify.forEach((user_id) => {
      const index = Users.findIndex((User) => User.value == user_id);
      if (index != -1) Group_Modify_Names.push(Users[index].label);
    });
    this.setState({ Group_Read_Names, Group_Copy_Names, Group_Modify_Names });
  };

  handleChangeName = (newText) => {
    // Any character except < > (HTML) and invisible control characters
    // (2026-10-17). The old whitelist — letters, digits, space and a few
    // symbols — silently ignored apostrophes ("Julian's Airplanes"), accents
    // ("Côte d'Azur") and "&".
    if (/[<>\u0000-\u001F\u007F]/.test(newText)) return;
    this.setState({ ...this.state, Name: newText });
  };
  handleChangeDescription = (newText) => { this.setState({ ...this.state, Description: newText }); };
  handleChangeRating = (newText) => { this.setState({ ...this.state, Rating: newText }); };

  addGuideAttributes = () => {
    const mode = this.props.mode;
    if (mode != "ADD") {
      this._addGuideAttributes();
      return;
    }
    this.MyAlert("Confirmation", "This will erase any unsaved changes to the current guide. Continue?", [
      { Title: "OK", Method: () => this._addGuideAttributes() },
      { Title: "CANCEL", Method: null },
    ]);
  };

  _addGuideAttributes = () => {
    if (this.state.Name == "") {
      this.MyAlert("Message", "Must specify Name", [{ Title: "OK", Method: null }]);
      return;
    }
    const mode = this.props.mode;
    let modified_guide_attributes = JSON.parse(JSON.stringify(window.guide_obj.attributes));
    const callback = this.props.callback;
    let Access = [];
    Access.push(this.props.user_info.uid);
    if (this.state.ShareAll == "Read") Access.push("All_R");
    else if (this.state.ShareAll == "Copy") Access.push("All_C");
    else if (this.state.ShareAll == "Modify") Access.push("All_M");
    this.state.Group_Read.forEach((user_id) => { Access.push(user_id + ":R"); });
    this.state.Group_Copy.forEach((user_id) => { Access.push(user_id + ":C"); });
    this.state.Group_Modify.forEach((user_id) => { Access.push(user_id + ":M"); });
    if (mode == "ADD") {
      let new_guide_attributes = new GuideAttributes(
        this.state.Name,
        this.state.Description,
        this.state.image,
        this.state.Language,
        parseInt(this.state.Rating),
        this.state.Countries,
        this.state.Cities
      );
      // GuideAttributes' constructor always sets image_m to "" regardless of
      // the image passed in — every automated cover-image flow
      // (BuildMyTripWizard.js/TripAI.js/PlacesHeader.js's
      // buildScheduleFromGuidePlaces-equivalent "Copy to Trip Itinerary")
      // checks attributes.image_m specifically to detect an existing custom
      // cover, so a cover set here would otherwise be invisible to all of
      // them. No separate thumbnail variant exists for a manually-picked
      // cover, so just mirror the same URL. Matches mobile's identical fix
      // in GuideEdit.js. Found 2026-09-06.
      new_guide_attributes.image_m = this.state.image;
      new_guide_attributes.access = Access;
      new_guide_attributes.user_id = this.props.user_info.uid;
      new_guide_attributes.mod = DateTime.now().toUTC().toISO();
      new_guide_attributes.base_location = {
        latitude: parseFloat(this.state.textValueLat),
        longitude: parseFloat(this.state.textValueLongi),
      };
      if (callback != null) callback(new_guide_attributes);
    } else {
      modified_guide_attributes.guide_name = this.state.Name;
      modified_guide_attributes.description = this.state.Description;
      // See the new-guide branch's identical comment above — image_m must
      // mirror image or every automated "does this guide already have a
      // custom cover" check silently ignores a manually-picked cover here.
      modified_guide_attributes.image = this.state.image;
      modified_guide_attributes.image_m = this.state.image;
      modified_guide_attributes.language = this.state.Language;
      modified_guide_attributes.rating = parseInt(this.state.Rating);
      modified_guide_attributes.countries = this.state.Countries;
      modified_guide_attributes.cities = this.state.Cities;
      modified_guide_attributes.access = Access;
      if (this.state.Featured === "Yes") modified_guide_attributes.type = "Featured";
      else modified_guide_attributes.type = "";
      window.guide_obj.attributes.modifyGuideAttributes(modified_guide_attributes);
      // Already in the cloud and yours: write the guide info now, so a share
      // (or a new name) takes effect without a full guide save.
      // Edit ("UPDATE") is only ever opened on the open guide — a Library
      // card shows another guide read-only ("VIEW", no Save).
      if (this.props.mode === "UPDATE" && this.props.guide_info_id != null && window.guide_obj.attributes.user_id === this.props.user_info.uid)
        DataBase.updateGuideInfoFields(this.props.guide_info_id, window.guide_obj.attributes);
      if (callback != null) callback();
    }
    this.props.onHide();
  };

  changeImage = () => {
    this.setState({
      ImageDialogShow: true,
      mode: "select",
      size: "medium",
      multi: false,
      updateImage: this.updateImageCallBack,
      name: this.state.Name,
      Photo: this.state.image,
      Photo_m: this.state.image,
    });
  };

  updateImageCallBack = (imageInfo) => {
    let attr = this.state.guideAttributes;
    this.setState({ guideAttributes: attr, image: imageInfo[0].url_m });
  };

  selectLanguage = () => {
    let _languages = [];
    const languages_sorted = languages.sort();
    let id = 0;
    languages_sorted.forEach((language) =>
      _languages.push({ label: language, name: language, value: language, id: (id++).toString() })
    );
    this.MultiSelect(_languages, [this.state.Language], "uni", this.selectedLanguage, "Select Language");
  };

  selectedLanguage = (language) => {
    if (language.length < 1) return;
    this.setState({ ...this.state, Language: language[0].label });
  };

  selectCountries = () => {
    let _countries = [];
    const countries_sorted = countries.sort();
    let id = 1;
    countries_sorted.forEach((country) =>
      _countries.push({ label: country, name: country, value: country, id: (id++).toString() })
    );
    this.MultiSelect(_countries, this.state.Countries, "multi", this.selectedCountry, "Select Countries");
  };

  selectedCountry = (countries) => {
    if (countries.length < 1) return;
    let _countries = [];
    countries.forEach((country) => { _countries.push(country.label); });
    this.setState({ ...this.state, Countries: _countries });
  };

  selectCities = () => {
    let _cities = JSON.parse(JSON.stringify(this.state.Cities));
    let cities_sorted = _cities.sort();
    this.setState({ CitiesShow: true, cities_sorted: cities_sorted });
  };

  updateCities = (cities) => { this.setState({ ...this.state, Cities: cities }); };

  // "All users can …" puts a guide in everyone's Library (guests too) with no
  // review, so only an admin may change it (2026-10-25). A guide keeps the
  // value it already has; others share by email (Read/Copy/Modify access).
  selectAccess = () => {
    if (window.admin_unlocked !== true) {
      this.MyAlert("Message", "Only an admin can share a guide with everyone — share it with people by email instead.", [{ Title: "OK", Method: null }]);
      return;
    }
    let _access = [];
    let id = 1;
    ["None", "Read", "Copy", "Modify"].forEach((access) =>
      _access.push({ label: access, name: access, value: access, id: (id++).toString() })
    );
    this.MultiSelect(_access, [this.state.ShareAll], "uni", this.selectedAccess, "Select Access Right");
  };

  selectedAccess = (access) => {
    if (access.length < 1) return;
    this.setState({ ...this.state, ShareAll: access[0].label });
  };

  getUsers = () => { DataBase.getAllUsers(this.getAllUsersCallback); };

  getAllUsersCallback = (res) => {
    if (res.pass == false) return;
    let _users = [];
    let id = 0;
    res.res.forEach((user) => {
      if (user.data.uid == this.props.user_info.uid) return;
      _users.push({
        label: `${user.data.first_name} ${user.data.last_name}`,
        name: user.data.uid,
        value: user.data.uid,
        id: (id++).toString(),
      });
    });
    if (this._processAccess == true) {
      this._processAccess = false;
      this.processGroups(_users);
      return;
    }
    _users.sort((a, b) => (a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1));
    this.setState({ Users: _users });
    if (this._usersRead == false) {
      this._usersRead = true;
      this.displayUsers(_users);
    }
  };

  _access = "";
  _usersRead = false;

  findUsers = (access) => {
    this._access = access;
    this.setState({ UsersDialogShow: true });
  };

  updateUsers = (users) => {
    let _users = [];
    let _user_names = [];
    users.forEach((user) => { _users.push(user.value); _user_names.push(user.label); });
    if (this._access === "Read")
      this.setState({ Group_Read: _users, Group_Read_Names: _user_names, Group_Read_List: users });
    else if (this._access === "Copy")
      this.setState({ Group_Copy: _users, Group_Copy_Names: _user_names, Group_Copy_List: users });
    else if (this._access === "Modify")
      this.setState({ Group_Modify: _users, Group_Modify_Names: _user_names, Group_Modify_List: users });
  };

  selectUsers = (access) => {
    this._access = access;
    if (this.state.Users.length === 0) {
      this._usersRead = false;
      this.getUsers();
      return;
    }
    this.displayUsers(this.state.Users, access);
  };

  displayUsers = (users) => {
    let selected = this.state.Group_Read;
    if (this._access === "Copy") selected = this.state.Group_Copy;
    else if (this._access === "Modify") selected = this.state.Group_Modify;
    let selectedUsers = [];
    selected.forEach((user_id) => {
      const index = users.findIndex((x) => x.value == user_id);
      if (index != -1)
        selectedUsers.push({ label: users[index].label, name: user_id, value: user_id });
    });
    this.MultiSelect(users, selectedUsers, "uni", this.selectedUsers, "Select Users");
  };

  selectedUsers = (users) => {
    let _users = [];
    let _user_names = [];
    users.forEach((user) => { _users.push(user.value); _user_names.push(user.label); });
    if (this._access === "Read") this.setState({ Group_Read: _users, Group_Read_Names: _user_names });
    else if (this._access === "Copy") this.setState({ Group_Copy: _users, Group_Copy_Names: _user_names });
    else if (this._access === "Modify") this.setState({ Group_Modify: _users, Group_Modify_Names: _user_names });
  };

  updateCoordinate = (coordinate, path) => {
    if (path == null)
      this.setState({ textValueLat: coordinate.latitude.toFixed(6), textValueLongi: coordinate.longitude.toFixed(6) });
  };

  // Mirrors mobile's GuideEdit.js "From map" option (MapDialog.js) — tap a
  // point on the map, confirm, done. No geocoding/address search on either
  // platform; this is deliberately just "point at a spot."
  pickLocationFromMap = () => this.setState({ LocationPickerShow: true });

  locationPicked = (lat, longi) => {
    this.setState({ textValueLat: lat.toFixed(6), textValueLongi: longi.toFixed(6) });
  };

  selectPlace = () => {
    let places = window.guide_obj.places.getPlacesToDisplay(null);
    this.MultiSelect(places, [], "uni", this.selectPlaceCallBack, "Select Place");
  };

  selectPlaceCallBack = (Places) => {
    let place = null;
    if (Places.length > 0) place = window.guide_obj.places.getPlace(Places[0].value);
    if (place != null) this.setState({ textValueLat: place.Lat, textValueLongi: place.Longi });
  };

  MyAlert = (title, message, buttons) => {
    this.setState({ AlertModalTitle: title, AlertModalMessage: message, AlertModalButtons: buttons, AlertModalShow: true });
  };

  getImageURLString = (str) => {
    return Common.getImageURL(str, Common.getFBPath(null, this.props.user_info), true);
  };

  MultiSelect = (Items, SelectedItems, Mode, Callback, Title) => {
    this.setState({
      MultiselectItems: Items,
      MultiselectSelectedItems: SelectedItems,
      MultiselectMode: Mode,
      MultiselectCallback: Callback,
      MultiselectTitle: Title,
      MultiselectSearchText: "",
      ShowMultiselect: true,
    });
  };

  updateFeatured = () => {
    this.setState({ Featured: this.state.Featured === "Yes" ? "No" : "Yes" });
  };

  switchToEdit = () => {
    this.props.callback(null, true);
  };

  render() {
    const attrs = this.state.guideAttributes;
    const mode = this.props.mode;
    const fmt = (n) => (n || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    let _countries = this.state.Countries.join(", ");
    let _cities = this.state.Cities.join(", ");

    if (this.state.CitiesShow)
      return (
        <CitiesDialog
          show={this.state.CitiesShow}
          onHide={() => this.setState({ CitiesShow: false })}
          cities={this.state.cities_sorted}
          callback={this.updateCities}
          update_display={null}
        />
      );
    if (this.state.LocationPickerShow)
      return (
        <LocationPickerDialog
          show={this.state.LocationPickerShow}
          onHide={() => this.setState({ LocationPickerShow: false })}
          initialLat={parseFloat(this.state.textValueLat)}
          initialLongi={parseFloat(this.state.textValueLongi)}
          onConfirm={this.locationPicked}
        />
      );
    if (this.state.ShowMultiselect)
      return (
        <MultiSelectModal
          show={this.state.ShowMultiselect}
          onHide={() => this.setState({ ShowMultiselect: false })}
          MultiselectItems={this.state.MultiselectItems}
          MultiselectSelectedItems={this.state.MultiselectSelectedItems}
          MultiselectMode={this.state.MultiselectMode}
          MultiselectCallback={this.state.MultiselectCallback}
          MultiselectTitle={this.state.MultiselectTitle}
          MultiselectSearchText={this.state.MultiselectSearchText}
        />
      );
    if (this.state.ImageDialogShow)
      return (
        <ImageDialog
          show={this.state.ImageDialogShow}
          onHide={() => this.setState({ ImageDialogShow: false })}
          user_info={this.props.user_info}
          mode={"select"}
          modify_only={"true"}
          updateImage={this.updateImageCallBack}
          size={"sm"}
          photo={this.state.Photo}
          photo_m={this.state.Photo_m}
          multi={false}
          exif={false}
          folder={this.props.folder}
          setImageFolder={this.props.setImageFolder}
        />
      );

    const renderRows = (rows) =>
      rows.map((r, i) => (
        <React.Fragment key={r.label}>
          {i > 0 && <div className="gem-divider" />}
          <div className="gem-row">
            <span className="gem-row-label">{r.label}</span>
            <span className={`gem-row-value${r.mono ? " gem-row-value--mono" : ""}`}>
              {r.value ?? "—"}
            </span>
          </div>
        </React.Fragment>
      ));

    if (mode === "VIEW") {
      const guideRows = [
        { label: "Name",        value: attrs.guide_name },
        { label: "Description", value: attrs.description },
        { label: "Language",    value: attrs.language },
        { label: "Featured",    value: this.state.Featured },
        { label: "URL",         value: `https://andiamoplaces.com?id=${this.state.guide_info_id}`, mono: true },
      ];
      const locationRows = [
        { label: "Countries",      value: _countries || "—" },
        { label: "Cities",         value: _cities || "—" },
        { label: "Base Location",  value: `${this.state.textValueLat}, ${this.state.textValueLongi}` },
      ];
      const statsRows = [
        { label: "Average Rating",  value: attrs.rating },
        { label: "Total Ratings",   value: fmt(attrs.num_ratings) },
        { label: "Times Read",      value: fmt(attrs.times_read) },
        { label: "Size",            value: `${fmt(JSON.stringify(window.guide_obj).length)} bytes` },
      ];
      const ownerRows = [
        { label: "Owner",          value: attrs.owner_name },
        { label: "Guide Access",   value: this.state.processed_guide_info.access_summary },
        { label: "Created",        value: `${Common.formatDateLuxon(attrs.created)} ${Common.formatTimeLuxon(attrs.created)}` },
        { label: "Last Read",      value: `${Common.formatDateLuxon(attrs.read)} ${Common.formatTimeLuxon(attrs.read)}` },
        { label: "Last Modified",  value: `${Common.formatDateLuxon(attrs.mod)} ${Common.formatTimeLuxon(attrs.mod)}` },
        { label: "Owner ID",       value: attrs.user_id, mono: true },
        { label: "Creator ID",     value: attrs.creator_id, mono: true },
        { label: "Guide ID",       value: this.state.guide_info_id, mono: true },
      ];

      const hasSharedUsers =
        this.state.Group_Read_Names.length > 0 ||
        this.state.Group_Copy_Names.length > 0 ||
        this.state.Group_Modify_Names.length > 0;
      const sharedRows = [
        ...(this.state.Group_Read_Names.length > 0
          ? [{ label: "Read", value: this.state.Group_Read_Names.join(", ") }] : []),
        ...(this.state.Group_Copy_Names.length > 0
          ? [{ label: "Copy", value: this.state.Group_Copy_Names.join(", ") }] : []),
        ...(this.state.Group_Modify_Names.length > 0
          ? [{ label: "Modify", value: this.state.Group_Modify_Names.join(", ") }] : []),
      ];

      return (
        <div className="modal">
          <Modal
            {...this.props}
            animation={false}
            dialogClassName="gem-dialog"
            aria-labelledby="gem-title"
            centered
            onHide={this.props.onHide}
          >
            <Modal.Body style={{ padding: 0 }}>
              <div className="gem-shell">

                {/* ── Header ── */}
                <div className="gem-header">
                  <div className="gem-header-icon">
                    <FontAwesomeIcon icon={icoBook} />
                  </div>
                  <h2 className="gem-title" id="gem-title">Guide Properties</h2>
                  {typeof this.props.callback === "function" && (
                    <button className="gem-edit-btn" onClick={this.switchToEdit}>
                      <FontAwesomeIcon icon={icoPen} />
                      Edit
                    </button>
                  )}
                  <button className="gem-close" onClick={this.props.onHide}>
                    <FontAwesomeIcon icon={icoXmark} />
                  </button>
                </div>

                {/* ── Body ── */}
                <div className="gem-body">
                  <span className="gem-section-label">Guide</span>
                  <div className="gem-card">{renderRows(guideRows)}</div>

                  <span className="gem-section-label">Location</span>
                  <div className="gem-card">{renderRows(locationRows)}</div>

                  <span className="gem-section-label">Statistics</span>
                  <div className="gem-card">{renderRows(statsRows)}</div>

                  <span className="gem-section-label">Ownership</span>
                  <div className="gem-card">{renderRows(ownerRows)}</div>

                  {hasSharedUsers && (
                    <>
                      <span className="gem-section-label">Shared With</span>
                      <div className="gem-card">{renderRows(sharedRows)}</div>
                    </>
                  )}
                </div>

              </div>
            </Modal.Body>
          </Modal>
        </div>
      );
    }

    /* ── EDIT / ADD mode ── */
    return (
      <div className="modal">
        <Modal
          {...this.props}
          animation={false}
          dialogClassName="gem-dialog"
          aria-labelledby="gem-title"
          centered
          onHide={this.props.onHide}
        >
          <Modal.Body style={{ padding: 0 }}>
            <div className="gem-shell">

              {/* ── Header ── */}
              <div className="gem-header">
                <div className="gem-header-icon">
                  <FontAwesomeIcon icon={icoPen} />
                </div>
                <h2 className="gem-title" id="gem-title">
                  {mode === "ADD" ? "New Guide" : "Edit Guide"}
                </h2>
                <button className="gem-save-btn" onClick={this.addGuideAttributes}>
                  <FontAwesomeIcon icon={icoCheck} />
                  Save
                </button>
                <button className="gem-close" onClick={this.props.onHide}>
                  <FontAwesomeIcon icon={icoXmark} />
                </button>
              </div>

              {/* ── Body ── */}
              <div className="gem-body">

                <span className="gem-section-label">Basic Info</span>

                {window.admin_unlocked === true && (
                  <div className="gem-check-row">
                    <span className="gem-check-label">Featured</span>
                    <input
                      type="checkbox"
                      className="gem-checkbox"
                      checked={this.state.Featured === "Yes"}
                      onChange={this.updateFeatured}
                    />
                  </div>
                )}

                <div className="gem-field-group">
                  <label className="gem-field-label">Name</label>
                  <input
                    className="gem-input"
                    type="text"
                    value={this.state.Name}
                    onChange={(e) => this.handleChangeName(e.target.value)}
                  />
                </div>

                <div className="gem-image-section">
                  <img
                    src={this.getImageURLString(this.state.image)}
                    className="gem-image"
                    referrerPolicy="no-referrer"
                    alt=""
                  />
                  <button className="gem-change-btn" onClick={this.changeImage}>
                    Change Image
                  </button>
                  {this.state.image ? (
                    <button className="gem-change-btn gem-clear-btn" onClick={() => this.setState({ image: "" })}>
                      Clear Image
                    </button>
                  ) : null}
                </div>

                <div className="gem-field-group">
                  <label className="gem-field-label">Description</label>
                  <textarea
                    className="gem-textarea"
                    value={this.state.Description}
                    onChange={(e) => this.handleChangeDescription(e.target.value)}
                  />
                </div>

                <span className="gem-section-label">Details</span>
                <div className="gem-card">
                  <button className="gem-selector-row" onClick={this.selectLanguage}>
                    <span className="gem-selector-label">Language</span>
                    <span className="gem-selector-value">{this.state.Language}</span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                  <div className="gem-divider" />
                  <button className="gem-selector-row" onClick={this.selectCountries}>
                    <span className="gem-selector-label">Countries</span>
                    <span className="gem-selector-value">{_countries || "None"}</span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                  <div className="gem-divider" />
                  <button className="gem-selector-row" onClick={this.selectCities}>
                    <span className="gem-selector-label">Cities</span>
                    <span className="gem-selector-value">{_cities || "None"}</span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                </div>

                {/* Base Location — used for map viewport bounds and as the
                    default "current location" for place distances before
                    real GPS resolves (see store/reducer.js). Matches
                    mobile's GuideEdit.js "Location" section: no geocoding,
                    just "tap a point on the map" or "reuse one of this
                    guide's own places' coordinates." */}
                <span className="gem-section-label">Location</span>
                <div className="gem-card">
                  <div className="gem-selector-row" style={{ cursor: "default" }}>
                    <span className="gem-selector-label">Coordinates</span>
                    <span className="gem-selector-value">{this.state.textValueLat}, {this.state.textValueLongi}</span>
                  </div>
                  <div className="gem-divider" />
                  <button className="gem-selector-row" onClick={this.pickLocationFromMap}>
                    <span className="gem-selector-label">From map</span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                  <div className="gem-divider" />
                  <button className="gem-selector-row" onClick={this.selectPlace}>
                    <span className="gem-selector-label">From place</span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                </div>

                <span className="gem-section-label">Sharing</span>
                <div className="gem-card">
                  {/* Sharing with everyone is admin-only (2026-10-25), so the
                      row only shows in admin mode (2026-10-26). A guide's
                      existing setting is kept on save either way. */}
                  {window.admin_unlocked === true && (
                    <>
                      <button className="gem-selector-row" onClick={this.selectAccess}>
                        <span className="gem-selector-label">All Users Can</span>
                        <span className="gem-selector-value">{this.state.ShareAll}</span>
                        <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                      </button>
                      <div className="gem-divider" />
                    </>
                  )}
                  <button className="gem-selector-row" onClick={() => this.findUsers("Read")}>
                    <span className="gem-selector-label">Read Access</span>
                    <span className="gem-selector-value">
                      {this.state.Group_Read_Names.length > 0
                        ? this.state.Group_Read_Names.join(", ")
                        : "None"}
                    </span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                  <div className="gem-divider" />
                  <button className="gem-selector-row" onClick={() => this.findUsers("Copy")}>
                    <span className="gem-selector-label">Copy Access</span>
                    <span className="gem-selector-value">
                      {this.state.Group_Copy_Names.length > 0
                        ? this.state.Group_Copy_Names.join(", ")
                        : "None"}
                    </span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                  <div className="gem-divider" />
                  <button className="gem-selector-row" onClick={() => this.findUsers("Modify")}>
                    <span className="gem-selector-label">Modify Access</span>
                    <span className="gem-selector-value">
                      {this.state.Group_Modify_Names.length > 0
                        ? this.state.Group_Modify_Names.join(", ")
                        : "None"}
                    </span>
                    <FontAwesomeIcon icon={icoChevR} className="gem-selector-chevron" />
                  </button>
                </div>

              </div>
            </div>
          </Modal.Body>
        </Modal>

        {this.state.UsersDialogShow && (
          <UsersDialog
            show={this.state.UsersDialogShow}
            onHide={() => this.setState({ UsersDialogShow: false })}
            users={
              this._access === "Read"
                ? this.state.Group_Read_List
                : this._access === "Copy"
                ? this.state.Group_Copy_List
                : this.state.Group_Modify_List
            }
            callback={this.updateUsers}
            user_info={this.props.user_info}
            update_display={null}
          />
        )}

        {this.state.AlertModalShow && (
          <AlertModal
            show={this.state.AlertModalShow}
            onHide={() => this.setState({ AlertModalShow: false })}
            AlertModalTitle={this.state.AlertModalTitle}
            AlertModalMessage={this.state.AlertModalMessage}
            AlertModalButtons={this.state.AlertModalButtons}
          />
        )}
      </div>
    );
  }
}

export default GuideEditModal;
